export const isInitialApiSecret = (apiSecret: string) => apiSecret.includes('*****')
